/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
==========================================================================================*/

const actions = {

    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    updateVerticalNavMenuWidth({commit}, width) {
        commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
    },

    // VxAutoSuggest
    updateStarredPage({commit}, payload) {
        commit('UPDATE_STARRED_PAGE', payload)
    },

    // The Navbar
    arrangeStarredPagesLimited({commit}, list) {
        commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({commit}, list) {
        commit('ARRANGE_STARRED_PAGES_MORE', list)
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({commit}) {
        commit('TOGGLE_CONTENT_OVERLAY')
    },
    updateTheme({commit}, val) {
        commit('UPDATE_THEME', val)
    },

    // /////////////////////////////////////////////
    // Global Error/Success handling
    // /////////////////////////////////////////////

    displayError({dispatch}, {message, error}) {

        if (error.response && error.response.status !== 499 && error.response.status !== 498 && error.response.status !== 422) {
            const nofitication = {
                type: 'danger',
                message: `${message} : ${(error.response && error.response.data.error) ? error.response.data.error : error.message}`
            }
            dispatch('notification/add', nofitication, {root: true})
        }

        if (error.response && (error.response.status === 498 || error.response.status === 422)) {
            if (error.response.data.error) {
                for (let property in error.response.data.error) {
                    if (error.response.data.error.hasOwnProperty(property)) {
                        //foreach error.response.data.error[property] dispatch
                        error.response.data.error[property].forEach((message) => {
                            const nofitication = {
                                type: 'danger',
                                message: `${message}`
                            }
                            dispatch('notification/add', nofitication, {root: true})
                        })
                    }
                }
            }

            if (error.response.data.errors) {
                for (let property in error.response.data.errors) {
                    if (error.response.data.errors.hasOwnProperty(property)) {
                        //foreach error.response.data.error[property] dispatch
                        error.response.data.errors[property].forEach((message) => {
                            const nofitication = {
                                type: 'danger',
                                message: `${message}`
                            }
                            dispatch('notification/add', nofitication, {root: true})
                        })
                    }
                }
            }

            if(error.response.data.message){
                const nofitication = {
                    type: 'danger',
                    message: `${error.response.data.message}`
                }
                dispatch('notification/add', nofitication, {root: true})
            }

        }
    },

    displaySuccess({dispatch}, message) {
        const nofitication = {
            type: 'success',
            message: `${message}`
        }
        dispatch('notification/add', nofitication, {root: true})
    }
}

export default actions
